import React, { useEffect, useState } from 'react';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Nav, NavItem, NavLink, Row } from 'reactstrap';

// Componentes
import MainCard from '../../../../../components/MainCard';
import Identificacao from './Identificacao';
import PermissoesPerfil from './PermissoesPerfil';

// Helpers
import { showMessage } from '../../../../../helpers/message';

// API
import perfil_api from '../../../../../api/perfil_api';

// Context
import { useAuth } from '../../../../../context/auth';

function initialStatePerfil(secretaria_id = 4) {
    return {
        identificacao: "",
        status: "Ativo",
        tipo: "Gestor",
        acessaAPP: "false",
        Secretaria_Id: secretaria_id
    }
}

function CadastroPerfil({ id = null, handleVoltar, editavel }) {
    //State para criar/editar
    const [perfil, setPerfil] = useState(initialStatePerfil());

    //State de controle do passo ativo
    const [activeStep, setActiveStep] = useState(1);

    const { setLoading } = useAuth();

    const loadPerfilItem = (id) => {
        if (id != null || perfil.id != null) {
            perfil_api.getItem(id ?? perfil.id).then(response => {
                response.data.acessaAPP = response.data.acessaAPP.toString();
                setPerfil(response.data);
            })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    useEffect(() => {
        loadPerfilItem(id);
    }, [])

    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 1:
                return <Identificacao
                    perfil={perfil}
                    setPerfil={setPerfil}
                    loadPerfilItem={loadPerfilItem}
                    editavel={editavel}
                />
            case 2:
                return <PermissoesPerfil
                    perfil={perfil}
                    setPerfil={setPerfil}
                    handleVoltar={handleVoltar}
                    editavel={editavel}
                />
        }
    }

    return <>
        <Button
            onClick={handleVoltar}
            className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' /> Voltar
        </Button>
        <MainCard>
            <h4 style={{ color: "#666" }}>Perfil</h4>
            <Nav tabs>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 1 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 1 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => { setActiveStep(1); }}
                    >
                        Dados de Identificação
                    </NavLink>
                </NavItem>
                <NavItem className='ms-2'>
                    <NavLink
                        role='button'
                        style={{ backgroundColor: activeStep == 2 ? "#fff" : "#ccc" }}
                        className={`${activeStep == 2 ? "active fw-bold text-success" : "text-secondary "}`}
                        onClick={() => {
                            if (!perfil.id) {
                                showMessage("Aviso", "Salve a identificação do Perfil para acessar as permissões.", "info", null);
                                return;
                            }

                            setActiveStep(2);
                        }}
                    >
                        Permissões de Acesso
                    </NavLink>
                </NavItem>
            </Nav>
            <div className="mt-4">
                {getContent()}
            </div>
        </MainCard>
    </>;
}

export default CadastroPerfil;